var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"review-detail-content"}},[_vm._v("\n    dfszdfz\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }